function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m451.93 193.511c-.762-7.661-7.222-13.506-14.927-13.506h-61-90c-4.233 0-8.276 1.787-11.118 4.937-2.842 3.135-4.233 7.339-3.809 11.558l8.994 90 95.933-1.593 84.921-1.395z",
  fill: "#76e2f8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m451.93 193.511c-.762-7.661-7.222-13.506-14.927-13.506h-61v104.901l84.921-1.395z",
  fill: "#73bcff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m497.003 270.005h-121-150.996l59.319 137h91.677 119.667l16.172-119.773c1.346-9.029-5.645-17.227-14.839-17.227z",
  fill: "#f0f7ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m511.842 287.232c1.346-9.029-5.645-17.227-14.839-17.227h-121v137h119.667z",
  fill: "#dfe7f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m411.573 468.499c-2.546-25.49 16.51-46.494 41.924-46.494 24.434 0 45.498 19.116 47.93 43.506 1.23 12.319-2.505 23.979-10.518 32.827-25.468 28.132-75.342 10.215-79.336-29.839z",
  fill: "#58072a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m268.073 468.499c-2.546-25.49 16.51-46.494 41.924-46.494 24.434 0 45.498 19.116 47.93 43.506 1.23 12.319-2.505 23.979-10.518 32.827-25.468 28.132-75.342 10.215-79.336-29.839z",
  fill: "#6d1d40"
}), /*#__PURE__*/React.createElement("path", {
  d: "m309.997 452.005c-7.78 0-12.842 5.875-12.07 13.506 1.26 12.627 19.673 21.035 27.231 12.7 2.256-2.49 3.296-5.947 2.915-9.712-.893-8.935-9.17-16.494-18.076-16.494z",
  fill: "#f0f7ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200.397 194.244-63.647-63.633c-5.86-5.86-5.856-15.355 0-21.211l63.647-63.647c5.862-5.862 15.355-5.856 21.211 0l63.633 63.647c5.859 5.859 5.859 15.352 0 21.211l-63.633 63.633c-5.859 5.859-15.351 5.859-21.211 0z",
  fill: "#9cdd05"
}), /*#__PURE__*/React.createElement("path", {
  d: "m346.003 150.005c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z",
  fill: "#ec577d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.629 72.837c-6.602-23.955 7.457-48.735 31.465-55.313l57.846-15.893c23.848-6.621 49.75 7.544 56.313 31.465 6.592 23.906-7.529 48.721-31.45 55.298 0 0 0 0-.015 0l-58.861 15.908c-23.84 6.622-48.708-7.411-55.298-31.465z",
  fill: "#fabe2c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136.003 362.005h-121c-8.291 0-15-6.709-15-15s6.709-15 15-15h121c8.291 0 15 6.709 15 15s-6.709 15-15 15z",
  fill: "#f0f7ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m196.003 422.005h-121c-8.291 0-15-6.709-15-15s6.709-15 15-15h121c8.291 0 15 6.709 15 15s-6.709 15-15 15z",
  fill: "#f0f7ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m453.497 452.005c-7.78 0-12.842 5.875-12.07 13.506 1.26 12.627 19.644 21.035 27.231 12.7 2.256-2.49 3.296-5.947 2.915-9.712-.893-8.935-9.17-16.494-18.076-16.494z",
  fill: "#dfe7f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m480.509 392.005h-104.506-89.15l-74.077-172.962c-2.388-5.493-7.793-9.038-13.77-9.038h-60c-8.291 0-15 6.709-15 15s6.709 15 15 15h50.156l74.077 172.962c2.388 5.493 7.793 9.038 13.77 9.038h98.994 104.506c8.291 0 15-6.709 15-15s-6.709-15-15-15z",
  fill: "#dfe7f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m495.509 407.005c0-8.291-6.709-15-15-15h-104.506v30h104.506c8.291 0 15-6.709 15-15z",
  fill: "#c5d3dd"
}));

var SvgGrowShop = function SvgGrowShop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.008 512.008",
    height: 512,
    viewBox: "0 0 512.008 512.008",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrowShop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grow-shop.b9bc0789.svg";
export { ForwardRef as ReactComponent };